import { Observable } from 'rxjs';
import { filter, first } from 'rxjs/operators';

/**
 * Custom RxJS operator that combines filter and first operators.
 * It filters values based on the provided predicate and then takes only the first value.
 *
 * @param predicate A function that evaluates each value emitted by the source Observable.
 * @returns An Observable that emits only the first value that passes the predicate test.
 */
export function filterFirst<T>(predicate: (value: T) => boolean) {
  return (source: Observable<T>): Observable<T> => {
    return source.pipe(
      filter(predicate),
      first()
    );
  };
}
